import { apiGet, apiPost, apiDelete } from '../api-client.ts';

interface ArchivioRecord {
  id: number;
  codFiscale: string;
  codPerCassa: Record<string, string | null>;
  cognNome: string | null;
  operatore: string | null;
  operatoreNome: string | null;
  origine: string;
  cognome: string | null;
  nome: string | null;
  datapres: string | null;
  dataNascita: string | null;
}

interface ListaResult {
  archivio: ArchivioRecord[];
  count: number;
  page: number;
  totalPages: number;
  pageSize: number;
}

export const archivioApi = {
  lista: (params: Record<string, string | number | undefined> = {}) => {
    const qs = Object.entries(params)
      .filter(([, v]) => v != null && v !== '')
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
      .join('&');
    return apiGet<ListaResult>(`archivio/lista${qs ? `?${qs}` : ''}`);
  },

  crea: (data: { codiceFiscale: string; operatore?: string; note?: string }) =>
    apiPost<ArchivioRecord>('archivio', data),

  elimina: (id: number) =>
    apiDelete<{ ok: boolean }>(`archivio/${id}`),
};
